import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuthContext } from '@/app/providers'
import { ROUTES } from '@/app/config'
import { useAuthStore } from '@/features/auth/store'

interface AuthGuardProps {
  children: ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuthContext()
  const location = useLocation()
  const pendingErpSelection = useAuthStore((state) => state.pendingErpSelection)

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  // Administrador con varias bases ERP que aún no eligió: el login le muestra el selector
  if (!isAuthenticated || pendingErpSelection) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  return <>{children}</>
}
